import { render, staticRenderFns } from "./farmer-customer-multiselect-ajax.vue?vue&type=template&id=c0128c6c&scoped=true&"
import script from "./farmer-customer-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./farmer-customer-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0128c6c",
  null
  
)

export default component.exports